import { Button, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_FIELDS_FLOATING_BUTTON_BACKGROUND,
  DARK_SECONDARY_BUTTONBACKGROUND,
  DARK_TEXT,
  ERROR_CIRCULAR_PROGRESS_BAR,
  ERROR_TEXT,
  LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  OFFWHITE_BUTTON_BACKGROUND,
  PASS_CIRCULAR_PROGRESS_BAR,
  PLAIN_TEXT,
  WARNING_CIRCULAR_PROGRESS_BAR,
} = COLORS;

export const EditProfileSideInfoContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '100%',
  display: 'grid',
  gap: 10,
  gridTemplateColumns: 'repeat(1,1fr)',
  [theme.breakpoints.up('lg')]: {
    maxWidth: '300px',
  },
}));

export const EditProfileSideInfoActions = styled('div')(({ theme }) => ({
  display: 'grid',
  width: '100%',
  gap: 10,
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: 2,
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
  [theme.breakpoints.up('lg')]: {
    gridColumn: 1,
    gridTemplateColumns: 'repeat(1, 1fr)',
  },
}));

export const EditProfileProgressText = styled('p')(({ theme, progress }: { theme: Theme; progress: number }) => ({
  textTransform: 'uppercase',
  fontSize: '14px',
  fontWeight: 500,
  color:
    progress < 50
      ? ERROR_CIRCULAR_PROGRESS_BAR
      : progress === 100
        ? PASS_CIRCULAR_PROGRESS_BAR
        : WARNING_CIRCULAR_PROGRESS_BAR,
  marginBottom: 10,
}));

export const EditProfileSideInfoActionsButton = styled(Button)(({ theme }) => ({
  backgroundColor:
    theme.palette.type === 'dark' ? DARK_FIELDS_FLOATING_BUTTON_BACKGROUND : LIGHT_FIELDS_FLOATING_BUTTON_BACKGROUND,
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  fontWeight: 500,
  width: '100%',
  boxShadow: 'none',
  fontSize: 12,
  height: 40,
  borderRadius: 8,
  '&:hover': {
    background: theme.palette.type === 'dark' ? DARK_SECONDARY_BUTTONBACKGROUND : OFFWHITE_BUTTON_BACKGROUND,
    boxShadow: 'none',
  },
  '&.edit-profile-delete': {
    color: ERROR_TEXT,
  },
  [theme.breakpoints.up('sm')]: {
    fontSize: 14,
    height: 50,
  },
  [theme.breakpoints.up('md')]: {
    fontSize: 14,
    height: '100%',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: 16,
    height: 60,
  },
}));
